/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DashboardPdfResponse
 */
export interface DashboardPdfResponse {
  /**
   *
   * @type {string}
   * @memberof DashboardPdfResponse
   */
  base64EncodedPdf: string;
}

/**
 * Check if a given object implements the DashboardPdfResponse interface.
 */
export function instanceOfDashboardPdfResponse(
  value: object,
): value is DashboardPdfResponse {
  if (!("base64EncodedPdf" in value) || value["base64EncodedPdf"] === undefined)
    return false;
  return true;
}

export function DashboardPdfResponseFromJSON(json: any): DashboardPdfResponse {
  return DashboardPdfResponseFromJSONTyped(json, false);
}

export function DashboardPdfResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DashboardPdfResponse {
  if (json == null) {
    return json;
  }
  return {
    base64EncodedPdf: json["base64EncodedPdf"],
  };
}

export function DashboardPdfResponseToJSON(json: any): DashboardPdfResponse {
  return DashboardPdfResponseToJSONTyped(json, false);
}

export function DashboardPdfResponseToJSONTyped(
  value?: DashboardPdfResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    base64EncodedPdf: value["base64EncodedPdf"],
  };
}
